/* eslint-disable */
import React, { useState, useEffect } from "react";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";

// Material-UI Icons
import Assessment from "@material-ui/icons/Assessment";
import Assignment from "@material-ui/icons/Assignment";
import HourglassEmpty from "@material-ui/icons/HourglassEmpty";
import CheckCircle from "@material-ui/icons/CheckCircle";
import Cancel from "@material-ui/icons/Cancel";
import Refresh from "@material-ui/icons/Refresh";
import GetApp from "@material-ui/icons/GetApp";
import TrendingUp from "@material-ui/icons/TrendingUp";
import PieChart from "@material-ui/icons/PieChart";
import People from "@material-ui/icons/People";
import OpenInNew from "@material-ui/icons/OpenInNew";
import ArrowForward from "@material-ui/icons/ArrowForward";
import Lock from "@material-ui/icons/Lock";
import DateRange from "@material-ui/icons/DateRange";

// Material-UI Core
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Chip,
    LinearProgress,
    Tooltip,
    IconButton,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Typography,
    Box
} from "@material-ui/core";

// Core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import "./custom-style.css";

var moment = require("moment");
require("moment/locale/th");

const customStyles = {
    ...styles,
    thaiFont: {
        fontFamily: '"Sarabun", sans-serif'
    },
    stepCard: {
        padding: "16px",
        borderRadius: "8px",
        textAlign: "center",
        color: "#fff",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },
    stepNumber: {
        fontSize: "13px",
        fontWeight: "bold",
        opacity: 0.9,
        marginBottom: "4px"
    },
    stepTitle: {
        fontSize: "15px",
        fontWeight: "600",
        marginBottom: "8px"
    },
    stepCount: {
        fontSize: "26px",
        fontWeight: "bold"
    },
    progressBarContainer: {
        marginBottom: "12px"
    },
    progressBarLabel: {
        display: "flex",
        justifyContent: "space-between",
        fontSize: "13px",
        marginBottom: "4px"
    },
    statusBadge: {
        fontWeight: "bold",
        fontSize: "12px",
        color: "#fff",
        borderRadius: "12px",
        padding: "4px 10px",
        display: "inline-block"
    },
    tableHeaderCell: {
        fontWeight: "bold",
        color: "#495057",
        fontSize: "13px",
        fontFamily: '"Sarabun", sans-serif'
    },
    tableBodyCell: {
        fontSize: "13px",
        fontFamily: '"Sarabun", sans-serif'
    }
};

const useStyles = makeStyles(customStyles);

export default function Dashboard(props) {
    const classes = useStyles();

    // Check authorization: only 'duangdao' and 'madarakung'
    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    const isAuthorized =
        currentUser &&
        (currentUser.userName === "duangdao" || currentUser.userName === "madarakung");

    const [fiscalYear, setFiscalYear] = useState(() => {
        let currentYear = parseInt(moment().format("BBBB"));
        if (moment().month() >= 9) {
            currentYear += 1;
        }
        return currentYear;
    });

    const [yearOptions, setYearOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [data, setData] = useState({
        summary: {
            totalRequests: 0,
            totalPending: 0,
            totalCompleted: 0,
            totalCancelled: 0,
            pendingStep4: 0,
            pendingStep3: 0,
            pendingStep2: 0,
            pendingStep1: 0
        },
        byServiceType: [],
        monthlyData: [],
        topRequesters: [],
        recentRequests: []
    });

    // Populate Year Options
    useEffect(() => {
        let currentYear = parseInt(moment().format("BBBB"));
        if (moment().month() >= 9) {
            currentYear += 1;
        }
        const options = [];
        for (let y = currentYear + 1; y >= currentYear - 4; y--) {
            options.push(y);
        }
        setYearOptions(options);
    }, []);

    // Load Dashboard Summary Data
    const loadDashboardData = async (year) => {
        if (!isAuthorized) return;
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get(
                `/api/v1/service-request/dashboard-summary?fiscalYear=${year}`
            );
            if (response.data && response.data.success) {
                setData({
                    summary: response.data.summary || {},
                    byServiceType: response.data.byServiceType || [],
                    monthlyData: response.data.monthlyData || [],
                    topRequesters: response.data.topRequesters || [],
                    recentRequests: response.data.recentRequests || []
                });
            } else {
                setError(response.data.message || "ไม่สามารถดึงข้อมูลสรุปได้");
            }
        } catch (err) {
            console.error("Dashboard fetch error:", err);
            if (err.response && err.response.status === 403) {
                setError("คุณไม่มีสิทธิ์เข้าถึงข้อมูล Dashboard นี้ (เฉพาะคุณดวงดาวและผู้ดูแลระบบ)");
            } else {
                setError("เกิดข้อผิดพลาดในการโหลดข้อมูล Dashboard");
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadDashboardData(fiscalYear);
    }, [fiscalYear]);

    // Handle navigate to specific service request
    const handleViewRequest = (serviceRequestId) => {
        props.history.push({
            pathname: "/data-analysis/request",
            state: {
                ServiceRequestID: serviceRequestId
            }
        });
    };

    // Export to CSV Function
    const handleExportCSV = () => {
        if (!data.recentRequests || data.recentRequests.length === 0) {
            alert("ไม่มีข้อมูลที่จะส่งออก");
            return;
        }

        const headers = [
            "รหัสคำขอ (ID)",
            "วันที่ยื่นคำขอ",
            "หัวข้อโครงการวิจัย",
            "ประเภทบริการ",
            "ผู้ยื่นคำขอ",
            "กลุ่มงาน/ฝ่าย",
            "สถานะปัจจุบัน"
        ];

        const rows = data.recentRequests.map((r) => [
            `"${r.serviceRequestID || ""}"`,
            `"${moment(r.createDatetime).format("DD/MM/BBBB HH:mm")}"`,
            `"${(r.projectTitle || "").replace(/"/g, '""')}"`,
            `"${(r.serviceName || "").replace(/"/g, '""')}"`,
            `"${(r.requesterName || "").replace(/"/g, '""')}"`,
            `"${(r.departmentName || "").replace(/"/g, '""')}"`,
            `"${r.statusText || ""}"`
        ]);

        const csvContent =
            "\uFEFF" +
            [headers.join(","), ...rows.map((row) => row.join(","))].join("\r\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute(
            "download",
            `สรุปข้อมูลคำขอวิเคราะห์ข้อมูล_ปีงบประมาณ_${fiscalYear}.csv`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // If unauthorized access
    if (!isAuthorized) {
        return (
            <div style={{ padding: "30px", fontFamily: '"Sarabun", sans-serif' }}>
                <Card>
                    <CardHeader color="danger">
                        <h4 style={{ margin: 0, fontWeight: "bold", color: "#fff" }}>
                            <Lock style={{ verticalAlign: "middle", marginRight: "8px" }} />
                            การเข้าถึงถูกจำกัด (Access Denied)
                        </h4>
                    </CardHeader>
                    <CardBody style={{ textAlign: "center", padding: "40px" }}>
                        <h5 style={{ color: "#d32f2f", marginBottom: "15px" }}>
                            คุณไม่มีสิทธิ์เข้าถึงหน้า Dashboard ภาพรวมนี้
                        </h5>
                        <p style={{ color: "#666", marginBottom: "25px" }}>
                            ระบบนี้สงวนสิทธิ์สำหรับคุณดวงดาวและผู้ดูแลระบบเท่านั้น
                        </p>
                        <Button
                            color="primary"
                            onClick={() => props.history.push("/data-analysis/request")}
                        >
                            กลับไปยังหน้าขอใช้บริการวิเคราะห์ข้อมูล
                        </Button>
                    </CardBody>
                </Card>
            </div>
        );
    }

    const { summary } = data;
    const nonCancelledTotal = summary.totalRequests - summary.totalCancelled;
    const completionRate =
        nonCancelledTotal > 0
            ? ((summary.totalCompleted / nonCancelledTotal) * 100).toFixed(1)
            : 0;

    return (
        <div style={{ fontFamily: '"Sarabun", sans-serif', paddingBottom: "30px" }}>
            {/* Top Bar: Title & Controls */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    marginBottom: "20px",
                    background: "#fff",
                    padding: "16px 24px",
                    borderRadius: "8px",
                    boxShadow: "0 1px 4px 0 rgba(0,0,0,0.14)"
                }}
            >
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Assessment
                        style={{
                            fontSize: "36px",
                            color: "#af2cc5",
                            marginRight: "12px"
                        }}
                    />
                    <div>
                        <h3
                            style={{
                                margin: 0,
                                fontWeight: "bold",
                                color: "#333",
                                fontSize: "22px"
                            }}
                        >
                            Dashboard ภาพรวมการขอใช้บริการวิเคราะห์ข้อมูลงานวิจัย
                        </h3>
                        <span style={{ fontSize: "13px", color: "#777" }}>
                            E-Service SKIN@Trang • ข้อมูลสรุปเฉพาะคุณดวงดาว และผู้พัฒนา
                        </span>
                    </div>
                </div>

                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        marginTop: "10px"
                    }}
                >
                    <FormControl variant="outlined" size="small" style={{ minWidth: 160 }}>
                        <InputLabel id="fiscal-year-label">ปีงบประมาณ</InputLabel>
                        <Select
                            labelId="fiscal-year-label"
                            value={fiscalYear}
                            onChange={(e) => setFiscalYear(e.target.value)}
                            label="ปีงบประมาณ"
                            style={{ fontFamily: '"Sarabun", sans-serif' }}
                        >
                            {yearOptions.map((y) => (
                                <MenuItem key={y} value={y}>
                                    ปีงบประมาณ {y}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <Button
                        color="info"
                        size="sm"
                        onClick={() => loadDashboardData(fiscalYear)}
                        disabled={loading}
                    >
                        <Refresh style={{ marginRight: "4px" }} />
                        {loading ? "กำลังโหลด..." : "รีเฟรช"}
                    </Button>

                    <Button
                        color="success"
                        size="sm"
                        onClick={handleExportCSV}
                        disabled={loading || data.recentRequests.length === 0}
                    >
                        <GetApp style={{ marginRight: "4px" }} />
                        ส่งออก CSV
                    </Button>
                </div>
            </div>

            {error && (
                <div
                    style={{
                        padding: "12px 20px",
                        backgroundColor: "#ffebee",
                        color: "#c62828",
                        borderRadius: "6px",
                        marginBottom: "20px"
                    }}
                >
                    {error}
                </div>
            )}

            {loading && <LinearProgress color="secondary" style={{ marginBottom: "20px" }} />}

            {/* Section 1: Main 4 KPI Cards */}
            <GridContainer>
                {/* Total Requests */}
                <GridItem xs={12} sm={6} md={3}>
                    <Card>
                        <CardHeader color="info" stats icon>
                            <CardIcon color="info">
                                <Assignment />
                            </CardIcon>
                            <p className={classes.cardCategory}>คำขอทั้งหมด</p>
                            <h3 className={classes.cardTitle}>
                                {summary.totalRequests}{" "}
                                <small style={{ fontSize: "14px", fontWeight: "normal" }}>
                                    รายการ
                                </small>
                            </h3>
                        </CardHeader>
                        <CardFooter stats>
                            <div className={classes.stats}>
                                <DateRange />
                                ประจำปีงบประมาณ {fiscalYear}
                            </div>
                        </CardFooter>
                    </Card>
                </GridItem>

                {/* In Progress */}
                <GridItem xs={12} sm={6} md={3}>
                    <Card>
                        <CardHeader color="warning" stats icon>
                            <CardIcon color="warning">
                                <HourglassEmpty />
                            </CardIcon>
                            <p className={classes.cardCategory}>อยู่ระหว่างดำเนินการ</p>
                            <h3 className={classes.cardTitle}>
                                {summary.totalPending}{" "}
                                <small style={{ fontSize: "14px", fontWeight: "normal" }}>
                                    รายการ
                                </small>
                            </h3>
                        </CardHeader>
                        <CardFooter stats>
                            <div className={classes.stats} style={{ color: "#e65100" }}>
                                <TrendingUp />
                                กำลังดำเนินการในขั้นตอนต่างๆ
                            </div>
                        </CardFooter>
                    </Card>
                </GridItem>

                {/* Completed */}
                <GridItem xs={12} sm={6} md={3}>
                    <Card>
                        <CardHeader color="success" stats icon>
                            <CardIcon color="success">
                                <CheckCircle />
                            </CardIcon>
                            <p className={classes.cardCategory}>ดำเนินการเสร็จสิ้น</p>
                            <h3 className={classes.cardTitle}>
                                {summary.totalCompleted}{" "}
                                <small style={{ fontSize: "14px", fontWeight: "normal" }}>
                                    รายการ
                                </small>
                            </h3>
                        </CardHeader>
                        <CardFooter stats>
                            <div className={classes.stats} style={{ color: "#2e7d32" }}>
                                <CheckCircle />
                                คิดเป็น {completionRate}% ของคำขอที่ดำเนินการ
                            </div>
                        </CardFooter>
                    </Card>
                </GridItem>

                {/* Cancelled */}
                <GridItem xs={12} sm={6} md={3}>
                    <Card>
                        <CardHeader color="danger" stats icon>
                            <CardIcon color="danger">
                                <Cancel />
                            </CardIcon>
                            <p className={classes.cardCategory}>ยกเลิก / ปฏิเสธ</p>
                            <h3 className={classes.cardTitle}>
                                {summary.totalCancelled}{" "}
                                <small style={{ fontSize: "14px", fontWeight: "normal" }}>
                                    รายการ
                                </small>
                            </h3>
                        </CardHeader>
                        <CardFooter stats>
                            <div className={classes.stats} style={{ color: "#c62828" }}>
                                <Cancel />
                                ยกเลิกคำขอ หรือไม่ผ่านเกณฑ์
                            </div>
                        </CardFooter>
                    </Card>
                </GridItem>
            </GridContainer>

            {/* Section 2: 4-Step Workflow Pipeline Status */}
            <Card style={{ marginTop: "15px" }}>
                <CardHeader color="primary">
                    <h4 style={{ margin: 0, fontWeight: "bold", color: "#fff" }}>
                        สถานะขั้นตอนการให้บริการทั้ง 4 ขั้นตอน (Workflow Pipeline)
                    </h4>
                    <p style={{ margin: "4px 0 0 0", color: "rgba(255,255,255,0.8)", fontSize: "13px" }}>
                        จำนวนคำขอที่กำลังรอการดำเนินการในแต่ละขั้นตอน
                    </p>
                </CardHeader>
                <CardBody>
                    <GridContainer>
                        {/* Step 1: Prepare Data (ApproveTypeKey = 4) */}
                        <GridItem xs={12} sm={6} md={3}>
                            <div
                                style={{
                                    ...customStyles.stepCard,
                                    background: "linear-gradient(135deg, #FF9800 0%, #F57C00 100%)"
                                }}
                            >
                                <div style={customStyles.stepNumber}>ขั้นตอนที่ 1 (ขั้นต้น)</div>
                                <div style={customStyles.stepTitle}>เตรียมข้อมูล</div>
                                <div style={customStyles.stepCount}>{summary.pendingStep4}</div>
                                <div style={{ fontSize: "12px", opacity: 0.9 }}>
                                    คำขอที่รอเตรียมข้อมูล
                                </div>
                            </div>
                        </GridItem>

                        {/* Step 2: Analyze Data (ApproveTypeKey = 3) */}
                        <GridItem xs={12} sm={6} md={3}>
                            <div
                                style={{
                                    ...customStyles.stepCard,
                                    background: "linear-gradient(135deg, #03A9F4 0%, #0288D1 100%)"
                                }}
                            >
                                <div style={customStyles.stepNumber}>ขั้นตอนที่ 2</div>
                                <div style={customStyles.stepTitle}>วิเคราะห์ข้อมูล</div>
                                <div style={customStyles.stepCount}>{summary.pendingStep3}</div>
                                <div style={{ fontSize: "12px", opacity: 0.9 }}>
                                    คำขอที่รอวิเคราะห์ข้อมูล
                                </div>
                            </div>
                        </GridItem>

                        {/* Step 3: Send Results to Researcher (ApproveTypeKey = 2) */}
                        <GridItem xs={12} sm={6} md={3}>
                            <div
                                style={{
                                    ...customStyles.stepCard,
                                    background: "linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%)"
                                }}
                            >
                                <div style={customStyles.stepNumber}>ขั้นตอนที่ 3</div>
                                <div style={customStyles.stepTitle}>ส่งผลให้ผู้วิจัย</div>
                                <div style={customStyles.stepCount}>{summary.pendingStep2}</div>
                                <div style={{ fontSize: "12px", opacity: 0.9 }}>
                                    คำขอที่รอส่งผลวิเคราะห์
                                </div>
                            </div>
                        </GridItem>

                        {/* Step 4: Explain Results (ApproveTypeKey = 1) */}
                        <GridItem xs={12} sm={6} md={3}>
                            <div
                                style={{
                                    ...customStyles.stepCard,
                                    background: "linear-gradient(135deg, #4CAF50 0%, #388E3C 100%)"
                                }}
                            >
                                <div style={customStyles.stepNumber}>ขั้นตอนที่ 4 (ขั้นสุดท้าย)</div>
                                <div style={customStyles.stepTitle}>อธิบายผลการวิเคราะห์</div>
                                <div style={customStyles.stepCount}>{summary.pendingStep1}</div>
                                <div style={{ fontSize: "12px", opacity: 0.9 }}>
                                    คำขอที่รออธิบายผลวิจัย
                                </div>
                            </div>
                        </GridItem>
                    </GridContainer>
                </CardBody>
            </Card>

            {/* Section 3: Charts & Breakdowns (2 Columns) */}
            <GridContainer style={{ marginTop: "10px" }}>
                {/* Monthly Trend Breakdown */}
                <GridItem xs={12} md={7}>
                    <Card>
                        <CardHeader color="info">
                            <h4 style={{ margin: 0, fontWeight: "bold", color: "#fff" }}>
                                <TrendingUp style={{ verticalAlign: "middle", marginRight: "6px" }} />
                                สถิติคำขอรับบริการรายเดือน (ปีงบประมาณ {fiscalYear})
                            </h4>
                            <p style={{ margin: "4px 0 0 0", color: "rgba(255,255,255,0.8)", fontSize: "13px" }}>
                                แนวโน้มจำนวนคำขอทั้งหมด และคำขอที่เสร็จสิ้น (ต.ค. - ก.ย.)
                            </p>
                        </CardHeader>
                        <CardBody>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={customStyles.tableHeaderCell}>เดือน</TableCell>
                                        <TableCell align="center" style={customStyles.tableHeaderCell}>
                                            คำขอทั้งหมด
                                        </TableCell>
                                        <TableCell align="center" style={customStyles.tableHeaderCell}>
                                            เสร็จสิ้น
                                        </TableCell>
                                        <TableCell style={customStyles.tableHeaderCell}>
                                            กราฟเปรียบเทียบ
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.monthlyData.map((m, index) => {
                                        const reqCount = m.requestCount != null ? m.requestCount : (m.count || 0);
                                        const compCount = m.completedCount || 0;
                                        const maxCount = Math.max(
                                            ...data.monthlyData.map((x) => (x.requestCount != null ? x.requestCount : (x.count || 0))),
                                            1
                                        );
                                        const pct = (reqCount / maxCount) * 100;
                                        return (
                                            <TableRow key={index} hover>
                                                <TableCell style={customStyles.tableBodyCell}>
                                                    <b>{m.monthName}</b>
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{
                                                        ...customStyles.tableBodyCell,
                                                        fontWeight: reqCount > 0 ? "bold" : "normal"
                                                    }}
                                                >
                                                    {reqCount > 0 ? (
                                                        <Chip
                                                            label={reqCount}
                                                            size="small"
                                                            style={{
                                                                backgroundColor: "#e3f2fd",
                                                                color: "#1976d2",
                                                                fontWeight: "bold"
                                                            }}
                                                        />
                                                    ) : (
                                                        <span style={{ color: "#aaa" }}>0</span>
                                                    )}
                                                </TableCell>
                                                <TableCell align="center" style={customStyles.tableBodyCell}>
                                                    {compCount > 0 ? (
                                                        <Chip
                                                            label={compCount}
                                                            size="small"
                                                            style={{
                                                                backgroundColor: "#e8f5e9",
                                                                color: "#2e7d32",
                                                                fontWeight: "bold"
                                                            }}
                                                        />
                                                    ) : (
                                                        <span style={{ color: "#aaa" }}>0</span>
                                                    )}
                                                </TableCell>
                                                <TableCell style={{ width: "45%" }}>
                                                    <div
                                                        style={{
                                                            background: "#eee",
                                                            borderRadius: "4px",
                                                            height: "12px",
                                                            overflow: "hidden"
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                width: `${pct}%`,
                                                                height: "100%",
                                                                background:
                                                                    "linear-gradient(90deg, #2196F3, #4CAF50)",
                                                                borderRadius: "4px",
                                                                transition: "width 0.4s ease"
                                                            }}
                                                        />
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </CardBody>
                    </Card>
                </GridItem>

                {/* Service Types & Top Requesters */}
                <GridItem xs={12} md={5}>
                    {/* By Service Type */}
                    <Card>
                        <CardHeader color="warning">
                            <h4 style={{ margin: 0, fontWeight: "bold", color: "#fff" }}>
                                <PieChart style={{ verticalAlign: "middle", marginRight: "6px" }} />
                                สัดส่วนตามประเภทบริการ
                            </h4>
                        </CardHeader>
                        <CardBody>
                            {data.byServiceType.length === 0 ? (
                                <p style={{ color: "#777", textAlign: "center", margin: "20px 0" }}>
                                    ไม่มีข้อมูลประเภทบริการในปีงบประมาณนี้
                                </p>
                            ) : (
                                data.byServiceType.map((svc, i) => (
                                    <div key={i} style={customStyles.progressBarContainer}>
                                        <div style={customStyles.progressBarLabel}>
                                            <span style={{ fontWeight: 600, color: "#444" }}>
                                                {svc.serviceName}
                                            </span>
                                            <span style={{ color: "#666" }}>
                                                <b>{svc.count}</b> ครั้ง ({svc.percentage}%)
                                            </span>
                                        </div>
                                        <div
                                            style={{
                                                background: "#f0f0f0",
                                                borderRadius: "6px",
                                                height: "10px",
                                                overflow: "hidden"
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: `${svc.percentage}%`,
                                                    height: "100%",
                                                    backgroundColor:
                                                        i === 0
                                                            ? "#2196F3"
                                                            : i === 1
                                                            ? "#4CAF50"
                                                            : i === 2
                                                            ? "#FF9800"
                                                            : "#9C27B0",
                                                    borderRadius: "6px"
                                                }}
                                            />
                                        </div>
                                    </div>
                                ))
                            )}
                        </CardBody>
                    </Card>

                    {/* Top 5 Requesters */}
                    <Card style={{ marginTop: "15px" }}>
                        <CardHeader color="success">
                            <h4 style={{ margin: 0, fontWeight: "bold", color: "#fff" }}>
                                <People style={{ verticalAlign: "middle", marginRight: "6px" }} />
                                ผู้ขอรับบริการสูงสุด 5 อันดับแรก
                            </h4>
                        </CardHeader>
                        <CardBody style={{ padding: "0 10px" }}>
                            {data.topRequesters.length === 0 ? (
                                <p style={{ color: "#777", textAlign: "center", margin: "20px 0" }}>
                                    ไม่มีข้อมูลผู้ขอรับบริการในปีงบประมาณนี้
                                </p>
                            ) : (
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={customStyles.tableHeaderCell}>ชื่อ-สกุล</TableCell>
                                            <TableCell style={customStyles.tableHeaderCell}>กลุ่มงาน/ฝ่าย</TableCell>
                                            <TableCell align="center" style={customStyles.tableHeaderCell}>
                                                คำขอ
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data.topRequesters.map((req, idx) => (
                                            <TableRow key={idx} hover>
                                                <TableCell style={customStyles.tableBodyCell}>
                                                    <b>{req.fullName}</b>
                                                    <div style={{ fontSize: "11px", color: "#777" }}>
                                                        {req.position}
                                                    </div>
                                                </TableCell>
                                                <TableCell style={customStyles.tableBodyCell}>
                                                    {req.department}
                                                </TableCell>
                                                <TableCell align="center" style={customStyles.tableBodyCell}>
                                                    <Chip
                                                        label={`${req.requestCount} ครั้ง`}
                                                        size="small"
                                                        color="primary"
                                                        style={{ fontWeight: "bold" }}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            )}
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>

            {/* Section 4: Recent Service Requests Table */}
            <Card style={{ marginTop: "20px" }}>
                <CardHeader color="primary">
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div>
                            <h4 style={{ margin: 0, fontWeight: "bold", color: "#fff" }}>
                                รายการขอใช้บริการล่าสุด (Recent Requests)
                            </h4>
                            <p style={{ margin: "4px 0 0 0", color: "rgba(255,255,255,0.8)", fontSize: "13px" }}>
                                25 รายการล่าสุดประจำปีงบประมาณ {fiscalYear} (คลิกดูรายละเอียดเพื่อเปิดคำขอได้ทันที)
                            </p>
                        </div>
                        <Button
                            color="transparent"
                            size="sm"
                            style={{ color: "#fff", border: "1px solid rgba(255,255,255,0.4)" }}
                            onClick={handleExportCSV}
                        >
                            <GetApp style={{ marginRight: "4px" }} />
                            ส่งออก Excel/CSV
                        </Button>
                    </div>
                </CardHeader>
                <CardBody>
                    {data.recentRequests.length === 0 ? (
                        <div style={{ textAlign: "center", padding: "40px", color: "#888" }}>
                            ไม่พบรายการคำขอใช้บริการในปีงบประมาณ {fiscalYear}
                        </div>
                    ) : (
                        <Table responsive>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={customStyles.tableHeaderCell}>วันที่ยื่น</TableCell>
                                    <TableCell style={customStyles.tableHeaderCell}>
                                        หัวข้อโครงการวิจัย
                                    </TableCell>
                                    <TableCell style={customStyles.tableHeaderCell}>ประเภทบริการ</TableCell>
                                    <TableCell style={customStyles.tableHeaderCell}>ผู้ขอรับบริการ</TableCell>
                                    <TableCell style={customStyles.tableHeaderCell}>กลุ่มงาน/ฝ่าย</TableCell>
                                    <TableCell align="center" style={customStyles.tableHeaderCell}>
                                        สถานะปัจจุบัน
                                    </TableCell>
                                    <TableCell align="center" style={customStyles.tableHeaderCell}>
                                        การกระทำ
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.recentRequests.map((r, i) => (
                                    <TableRow key={i} hover>
                                        <TableCell style={customStyles.tableBodyCell}>
                                            {moment(r.createDatetime).format("DD/MM/BBBB")}
                                            <div style={{ fontSize: "11px", color: "#888" }}>
                                                {moment(r.createDatetime).format("HH:mm น.")}
                                            </div>
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                ...customStyles.tableBodyCell,
                                                maxWidth: "280px",
                                                fontWeight: 500
                                            }}
                                        >
                                            <span title={r.projectTitle}>
                                                {r.projectTitle && r.projectTitle.length > 55
                                                    ? r.projectTitle.substring(0, 55) + "..."
                                                    : r.projectTitle}
                                            </span>
                                        </TableCell>
                                        <TableCell style={customStyles.tableBodyCell}>
                                            <span style={{ color: "#555" }}>{r.serviceName}</span>
                                        </TableCell>
                                        <TableCell style={customStyles.tableBodyCell}>
                                            <b>{r.requesterName}</b>
                                        </TableCell>
                                        <TableCell style={customStyles.tableBodyCell}>
                                            {r.departmentName}
                                        </TableCell>
                                        <TableCell align="center" style={customStyles.tableBodyCell}>
                                            <span
                                                style={{
                                                    ...customStyles.statusBadge,
                                                    backgroundColor: r.statusColor || "#ff9800"
                                                }}
                                            >
                                                {r.statusText}
                                            </span>
                                        </TableCell>
                                        <TableCell align="center" style={customStyles.tableBodyCell}>
                                            <Tooltip title="เปิดดูและจัดการคำขอนี้">
                                                <Button
                                                    color="primary"
                                                    size="sm"
                                                    round
                                                    style={{
                                                        padding: "6px 14px",
                                                        fontSize: "12px",
                                                        fontFamily: '"Sarabun", sans-serif'
                                                    }}
                                                    onClick={() => handleViewRequest(r.serviceRequestID)}
                                                >
                                                    เปิดดู
                                                    <OpenInNew
                                                        style={{
                                                            fontSize: "14px",
                                                            marginLeft: "4px"
                                                        }}
                                                    />
                                                </Button>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                </CardBody>
            </Card>
        </div>
    );
}
